import React from "react";
import { useNavigate } from "react-router-dom";

import ErrorModal from '../../modals/error_modal/ui/Main';

import useAnnouncementForm from '../hooks/useAnnouncementForm';

import AnnouncementDetailsForm from "./AnnouncementDetailsForm";
import ContactInfoForm from "./ContactInfoForm";

function EditForm({ announcementId, announcementData }) {
    const navigate = useNavigate();

    const {
        priceType, setPriceType,
        announcementName, handleAnnouncementInputChange,
        videoLink, handleVideoLinkChange,
        description, handleDescriptionChange,
        handleSelectCategory,
        price, setPrice,
        handleImagesChange,
        isSubmitted,
        userData,
        tagsArray,
        customTags, handleCustomTagsChange, handleAddTag, handleRemoveTag,
        additionalPhones, handleAddPhone, handlePhoneChange, handleDeletePhone,
        isLoading,
        showErrorModal, setShowErrorModal,
        errorMessage,
        handlePublish,
        handlePreview,
        phoneErrors,
        volumeUnit,
        handleVolumeChange,
    } = useAnnouncementForm(announcementData);

    const onPublish = async () => {
        const result = await handlePublish(announcementId);
        if (result.success) {
            navigate(`/announcement/${result.id}`);
        }
    };

    const onPreview = () => {
        const previewData = handlePreview();
        if (previewData) {
            navigate('/preview', { state: { previewData } });
        }
    };

    return (
        <div className="flex flex-wrap justify-between mt-5 pb-[100px] px-5 md:px-[60px] lg:px-[120px] xl:px-[240px]">
            <AnnouncementDetailsForm
                announcementData={announcementData}
                handleImagesChange={handleImagesChange}
                videoLink={videoLink}
                handleVideoLinkChange={handleVideoLinkChange}
                announcementName={announcementName}
                handleAnnouncementInputChange={handleAnnouncementInputChange}
                isSubmitted={isSubmitted}
                customTags={customTags}
                handleCustomTagsChange={handleCustomTagsChange}
                handleAddTag={handleAddTag}
                handleRemoveTag={handleRemoveTag}
                tagsArray={tagsArray}
                handleSelectCategory={handleSelectCategory}
                description={description}
                handleDescriptionChange={handleDescriptionChange}
                priceType={priceType}
                setPriceType={setPriceType}
                price={price}
                setPrice={setPrice}
                isLoading={isLoading}
                onPublish={onPublish}
                onPreview={onPreview}
                volumeUnit={volumeUnit}
                handleVolumeChange={handleVolumeChange}
            />

            <ContactInfoForm
                userData={userData}
                additionalPhones={additionalPhones}
                phoneErrors={phoneErrors}
                handlePhoneChange={handlePhoneChange}
                handleDeletePhone={handleDeletePhone}
                handleAddPhone={handleAddPhone}
                onPublish={onPublish}
                onPreview={onPreview}
                isLoading={isLoading}
            />
            {showErrorModal && (
                <ErrorModal
                    showLogoutModal={showErrorModal}
                    setShowLogoutModal={setShowErrorModal}
                    message={errorMessage}
                />
            )}
        </div>
    );
}

export default EditForm;